<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">{{$route.params.listId == 'prescribe_by_details' ? 'Doctor Detail' : $route.query.listTitle}}</v-toolbar-title>

		    <!-- <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back" @keyup.native.enter="checkEnter" >

			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->
			
			<v-layout wrap padding-top-bottom-ten white-background>

				<!-- <v-layout wrap class="section-wrapper"> -->

					<v-flex xs12 sm12 md12 form-item>
		               <v-text-field v-model="Form.name" label="Name" placeholder=" " v-validate="'required|max:50'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
		            </v-flex>
					
					<template v-if="$route.params.listId == 'prescribe_by_details'">
						<v-flex xs12 sm12 md12 form-item>
							<v-text-field v-model="Form.additionalData.prescribeDetails.regNumber" label="Reg. No." placeholder=" "></v-text-field>
						</v-flex>

						<v-flex xs12 sm12 md12 form-item>
							<v-text-field type="number" v-model="Form.additionalData.prescribeDetails.mobileNumber" label="Mobile No." placeholder=" "></v-text-field>
						</v-flex>

						<v-flex xs12 sm12 md12 form-item>
							<v-textarea rows="2" label="Address" placeholder=" " v-model="Form.additionalData.prescribeDetails.address"></v-textarea>
						</v-flex>
					</template>

					<template v-if="$route.params.listId == 'referred_by_details'">

						<v-flex xs12 sm12 md12 form-item>
							<v-text-field type="number" v-model="Form.additionalData.referenceDetails.mobileNumber" label="Mobile No." placeholder=" "></v-text-field>
						</v-flex>

						<v-flex xs12 sm12 md12 form-item>
							<v-textarea rows="2" label="Address" placeholder=" " v-model="Form.additionalData.referenceDetails.address"></v-textarea>
						</v-flex>
					</template>
			    
			</v-layout>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>
		</v-form>

	    <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	    <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

	</div>
</template>

<script>
const dialogjs =  require('../../dialog').dialogjs;
const menuItem = require('../../../../../config.js').configs.menuItem;

const systemLists = require('../../../../../config.js').configs.mastersPredefinedLists;

import dialogDiscard from '../../../../dialogs/dialog_discard'
import {draftMixin} from '../../../../draft_mixin'
// import dialogDraftItems from '../../../../dialogs/dialog_draft_items'

	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:{"description":null, "groupTypeId":801, "listId":null, "listItemsId":null, "name":null, "title":null, "listTitle":null, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null, 
					"additionalData":{
						"prescribeDetails":{'regNumber':null, 'mobileNumber':null, 'address':null},
						"referenceDetails":{'mobileNumber':null, 'address':null}
					}
				},
				loading:false,
				tagId:null,
				draftStorageId:null,
				snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				// loadedFromDraft:false,
				backButtonPress:false
			}
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                     // this.fn_saveToLocalStorage(this);
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		components:{
			'dialog-discard': dialogDiscard,
			// 'dialog-draft-items': dialogDraftItems
		},
		methods:{

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			checkEnter: function(event){
				if (event.keyCode == 13) {
			       return false;
			   }
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_checkValidations: function(){
				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			           self.fn_post();	
			          	return; 
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('ListItem', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	// self.snackbar = true;
				          	// self.snackbar_msg = "Already exists with this name";
				          	self.showToast("Already exists with this name");
				          }
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};

					data.type = this.$route.query.type ? this.$route.query.type : 'listItem';

					// if(this.Form.listId==systemLists.routeListGUID){
					// 	data.type = 'route';
					// }
					// else if(this.Form.listId==systemLists.brandListGUID){
			  //         	data.type = 'brand';
					// }
					// else if(this.Form.listId==systemLists.companyListGUID){
			  //         	data.type = 'company';
					// }

					data.id = this.Form.listItemsId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("master_items_state")){
						let obj = JSON.parse(localStorage.getItem("master_items_state"));
						obj.itemId = self.Form.listItemsId;
						localStorage.setItem("master_items_state",JSON.stringify(obj));
					}

					self.$router.go(-1);
				});
				
			},

			fn_post: function(){
				// !this.Form.listItemsId ? this.Form.listItemsId = this.guid() : '';
				if(!this.Form.listItemsId){
					this.Form.listItemsId = this.guid();
					// this.Form.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();
				this.Form.name = this.Form.name.trim();
				this.$route.params && this.$route.params.listId ? this.Form.listId = this.$route.params.listId : '';
				console.log(this.Form);
				if(this.$route.params.listId == 'prescribe_by_details'){
					this.Form.additionalData.prescribeDetails.name = this.Form.name;
				}

				if(this.$route.params.listId == 'referred_by_details'){
					this.Form.additionalData.referenceDetails.name = this.Form.name;
				}
				// this.Form.additionalData = JSON.stringify(this.Form.additionalData);
				this.fn_saveLocal(this.Form);
			},

			fn_get: function(itemId, copyData){
				var self = this;
				this.getData('ListItem', itemId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          self.unwatch = true;
				          self.Form = JSON.parse(response);
						  self.Form.additionalData = JSON.parse(self.Form.additionalData);

				          	if(copyData){
					          	self.Form.listItemsId=null;
					          	self.Form.isSystem = 0;
					   //        	self.snackbar = true;
								// self.snackbar_msg = "Data copied."
								self.showToast("List Item copied");
					        }

					        self.$root.fn_copyFormObject(self.Form, self.formId);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_clearForm: function(){
				this.Form = {"description":null, "groupTypeId":801, "listId":null, "listItemsId":null, "name":null, "title":null, "listTitle":null, "isSystem":0, "draftItems":[], "createdDate":null, "modifiedDate":null};
				this.$validator.reset();
			},

			// fn_saveToLocalStorage: function(){
			// 	if(!this.unwatch){
			// 		var dataObj = {};
			// 		dataObj.type = "List Item";
			// 		dataObj.formType = "new";
			// 		dataObj.modifiedDate = new Date();
			// 		dataObj.formId = this.formId;
			// 		dataObj.draftId = this.draftStorageId;
			// 		dataObj.uri = this.$route.path;
			// 		dataObj.dataModel = this.Form;
			// 		dataObj.dataModel.listTitle = this.$route.query.listTitle;
			// 		localStorage.setItem(this.draftStorageId, JSON.stringify(dataObj));
			// 	}
			// 	this.unwatch = false;
				
			// },

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use

				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;

				if(this.Form.listItemsId){
					this.fn_get(this.Form.listItemsId);
				}
				else{
					this.fn_clearForm();
				}
				
				// if(localStorage.getItem(this.draftStorageId)){
				// 	localStorage.removeItem(this.draftStorageId);
				// 	this.snackbar = true;
				// 	this.snackbar_msg = "Item deleted from draft";
				// }

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					console.log("draft deleted");
					// self.showToast("Item deleted from draft");
				});
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = this.$route.query.listTitle;
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;
				// viewObject.BottomMenu = [{"MenuID":2, "MenuType":null, "Icon":"save", "Text":"Save", "Action": "save"}]
				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			// fn_setFormDataFromLocalStorage: function () {
			// 	if(localStorage.getItem(this.draftStorageId)){
			// 		var formData = JSON.parse(localStorage.getItem(this.draftStorageId));
			// 		this.Form = formData.dataModel;

			// 		if((this.$route.query && this.$route.query.draft) || (this.$route.params && this.$route.params.tagId)){
			// 			this.loadedFromDraft = true;
			// 		}
			// 	} 
			// },

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){

			var self = this;

			// this.Form.listTitle = this.$route.query.listTitle;
			// this.Form.listId = this.$route.params.listId;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			window.js_globals.fn_onBackPress = this.fn_goBack;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			this.fn_showWebView();

	        if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				// this.fn_setFormDataFromLocalStorage();
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}

					// self.$route.query.tagId ? self.fn_checkDraftItems('List Item', true) : '';

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			// this.fn_setDraftData('Master', 'List Item', this.$route.params.listId, this.$route.query.listTitle);
			this.fn_setDraftData('temp', 'List Item', this.$route.params.listId, this.$route.query.listTitle);

		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){
					itemId = from.params.tagId;  			
		  		}

		  		//edit from list view
		  		if((from.name=='listsItemItems' || from.name=='transactionTypeForm' || from.name=='transactionTypeEditForm') && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'listsItemItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'listItemDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}
		  		
		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData);
		  		// 	}
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData);
	  			}
	  			else{
					vm.$root.fn_copyFormObject(vm.Form, vm.formId);  				
	  			}

		  		// if(itemId && !localStorage.getItem(vm.draftStorageId)){
		  		// 	vm.fn_get(itemId, copyData)
		  		// }
		  	})
		},
		beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					// this.$root.fn_deleteFormObject();
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{
				// if(this.askToDiscard){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData(null, function(){
						next();
					})
				}
				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	next();	
				// }
				
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/lists/list_items/form.vue